// "Você quis dizer fulano@icloud.com?" abaixo de um campo de e-mail (compartilhado/lib/email.ts). Tocar corrige;
// ignorar não impede salvar.
import { sugerirCorrecaoEmail } from "../lib/email";

export function SugestaoEmail({ email, aoCorrigir }: { email: string; aoCorrigir: (corrigido: string) => void }) {
  const sugestao = sugerirCorrecaoEmail(email);
  if (!sugestao) return null;
  const dominio = sugestao.slice(sugestao.lastIndexOf("@"));
  return (
    <p className="-mt-2 text-apoio text-texto-2" data-sugestao-email="">
      Você quis dizer{" "}
      <button
        type="button"
        className="font-semibold text-tinta underline underline-offset-4"
        onClick={() => aoCorrigir(sugestao)}
      >
        {dominio}
      </button>
      ?
    </p>
  );
}
